import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 rounded-lg border border-brand-accent/20 flex flex-col h-full hover:border-brand-accent/60 transition-colors shadow-[0_4px_20px_rgba(0,0,0,0.5)]" data-id="element-201">
    <div className="flex items-center mb-3" data-id="element-202">
      <div className="w-10 h-10 bg-brand-accent text-brand-dark rounded-full flex items-center justify-center font-black text-sm mr-3 shrink-0 shadow-[0_0_10px_rgba(0,255,136,0.4)]" data-id="element-203">
        {initials}
      </div>
      <div data-id="element-204">
        <div className="flex text-brand-accent mb-0.5" data-id="element-205">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-206" />)}
        </div>
        <p className="font-black text-white text-xs md:text-sm leading-tight uppercase" data-id="element-207">
          {name}
        </p>
        <p className="text-[10px] md:text-xs text-brand-accent font-bold" data-id="element-208">
          {location}
        </p>
      </div>
    </div>
    <p className="text-gray-300 text-xs md:text-sm italic flex-grow leading-relaxed font-medium" data-id="element-209">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    initials: 'MC',
    name: 'María C.',
    location: 'Docente de Bachillerato — Ciudad de México, México',
    text: 'Mis alumnos por fin dejan el celular y debaten con ganas.'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Profesor de Filosofía — Bogotá, Colombia',
    text: 'Nunca más llegué a una clase sin saber cómo explicar un autor difícil.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    location: 'Docente de Humanidades — Santiago, Chile',
    text: 'Las planificaciones me ahorran horas de tipeo y búsqueda. No improviso nunca más.'
  }];
  return <section className="py-4 md:py-5 px-4 bg-brand-cardAlt border-b border-brand-accent/10" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-212">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-213" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'MC',
    name: 'María C.',
    location: 'Docente de Ética | Ciudad de México, México',
    text: 'Lo que más valoro es el Bono de Actividades Anti-IA. Estaba cansada de que todos mis alumnos entregaran tareas hechas con ChatGPT. Con estas dinámicas de reflexión personal y casos reales, por fin puedo evaluar quién piensa de verdad y quién no. Es la mejor inversión que hice este año para mi carrera.'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Profesor de Ciudadanía | Bogotá, Colombia',
    text: 'Enseñar Política siempre fue un reto por la falta de materiales neutrales y actualizados. El Tomo 2 sobre el Panóptico Digital y Foucault es una joya. Los chicos se engancharon de inmediato analizando Instagram como una forma de vigilancia. Mis colegas me preguntan qué curso hice para renovar tanto mis clases.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    location: 'Profesora de Filosofía | Lima, Perú',
    text: 'El Tomo 1 sobre Lógica y Fake News me salvó. Mis alumnos de 4to año no querían saber nada con Aristóteles, pero cuando usamos el método socrático para analizar noticias de TikTok, la clase explotó. El material conecta la teoría clásica con su realidad diaria de forma brillante.'
  }, {
    initials: 'CR',
    name: 'Carlos R.',
    location: 'Docente de Ética | Montevideo, Uruguay',
    text: 'El Bono del Video-Club Filosófico vale por sí solo el precio del kit. Antes ponía una película y se dormían. Ahora, con las fichas de trabajo y las preguntas guía, ver Black Mirror o The Truman Show se convierte en un debate ético profundo que dura semanas.'
  }, {
    initials: 'DG',
    name: 'Daniel G.',
    location: 'Profesor de Filosofía | Caracas, Venezuela',
    text: 'La Guía de Dinámicas de Debate (Bono 4) transformó mis grupos. Tenía un salón donde nadie hablaba. Apliqué la técnica del "Abogado del Diablo" que viene en el kit y hasta los más tímidos empezaron a argumentar. Es un material hecho por alguien que realmente pisa el aula.'
  }];
  return <section className="py-5 md:py-6 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <h2 className="text-xl md:text-3xl font-black text-center mb-5 text-white uppercase tracking-tight" data-id="element-216">
          🗨️ LO QUE DICEN LOS DOCENTES QUE YA TIENEN SU KIT:
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-217">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-218" />)}
        </div>
      </div>
    </section>;
}